import React from 'react'
import { connect } from 'react-redux'
import { string, func } from 'prop-types'
import { productsDataType } from 'models/propTypes'

import { getDesignSidepanelMode } from 'models/ui/selectors'
import { getSelectedCompositionShoppableProductData } from 'models/compositions/selectors'
import MyItemsBrowseView from 'components/designSidepanel/MyItemsBrowseView'

import { addRoomToBag as addRoomToBagAction } from 'models/bag/actions'

const MyItemsBrowseViewContainer = ({ addedToRoomItems, mode, addRoomToBag }) => {
    const productIds = addedToRoomItems.map((item) => item.localItemNumber)
    const region = addedToRoomItems.length ? addedToRoomItems[0].region : null
    const trackingInfo = { ProductsAdded: addedToRoomItems.length }

    return (
        <MyItemsBrowseView
            addedToRoomItems={addedToRoomItems}
            mode={mode}
            addRoomToBag={() => addRoomToBag(productIds, region, trackingInfo)}
        />
    )
}

MyItemsBrowseViewContainer.propTypes = {
    addedToRoomItems: productsDataType.isRequired,
    mode: string.isRequired,
    addRoomToBag: func.isRequired,
}

const mapStateToProps = (state) => ({
    addedToRoomItems: getSelectedCompositionShoppableProductData(state),
    mode: getDesignSidepanelMode(state),
})
const mapDispatchToProps = {
    addRoomToBag: addRoomToBagAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(MyItemsBrowseViewContainer)
